import { SET_UNSAVED_CHANGES, SET_VISIT_LOCK } from "../actions/activityAction";

const initialState = {
    unsavedChanges: false,
    currentPath: null,
    activityLog: [],
    selectedVisit: {
        isVisitLocked: false,
        reportId: null
    }
};

const activityReducer = (state = initialState, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
            let currentPath = {
                name: action.payload.pathname,
                mount: new Date()
            };
            let logs = [...state.activityLog];
            if (state.currentPath) {
                logs.push({ ...state.currentPath, unmount: new Date() });
            }
            return {
                ...state,
                currentPath,
                activityLog: logs
            };
        case SET_UNSAVED_CHANGES:
            return {
                ...state,
                unsavedChanges: action.unsavedChanges
            };
        case SET_VISIT_LOCK:
            return {
                ...state,
                selectedVisit: { ...action.selectedVisit },
            }
        default:
            return state;
    }
};

export default activityReducer;
